var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleCircleRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1.3rem",
    height: "1.3rem",
    viewBox: "0 0 122.883 122.882",
    enableBackground: "new 0 0 122.883 122.882",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.441,0C44.475,0,29.115,6.877,17.996,17.996C6.877,29.115,0,44.475,0,61.441c0,16.966,6.877,32.326,17.996,43.445 c11.119,11.118,26.479,17.995,43.445,17.995c16.967,0,32.327-6.877,43.446-17.995c11.119-11.119,17.996-26.479,17.996-43.445 c0-16.967-6.877-32.327-17.996-43.445C93.768,6.877,78.408,0,61.441,0L61.441,0z M51.505,42.166 c-1.735-1.784-1.696-4.637,0.088-6.372c1.784-1.735,4.637-1.696,6.373,0.088l21.839,22.521l-3.23,3.142l3.244-3.146 c1.738,1.792,1.693,4.652-0.098,6.39c-0.053,0.05-0.105,0.099-0.158,0.146L57.966,87.017c-1.735,1.784-4.588,1.823-6.373,0.088 c-1.784-1.734-1.823-4.588-0.088-6.372l18.78-19.201L51.505,42.166L51.505,42.166z M24.386,24.386 C33.869,14.903,46.97,9.038,61.441,9.038c14.471,0,27.573,5.865,37.055,15.348c9.484,9.483,15.35,22.584,15.35,37.056 c0,14.471-5.865,27.572-15.35,37.055c-9.482,9.483-22.584,15.349-37.055,15.349c-14.471,0-27.572-5.865-37.055-15.349 C14.903,89.014,9.038,75.912,9.038,61.441C9.038,46.97,14.903,33.869,24.386,24.386L24.386,24.386z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleCircleRightIcon);
export default __webpack_public_path__ + "static/media/angle-circle-right-icon.37198b02c0367e373dfc6ae4f4f1d6aa.svg";
export { ForwardRef as ReactComponent };